import React from 'react';
import { Shield, Star, CheckCircle, Award } from 'lucide-react';
import { getTrustBadgeClass } from '../lib/utils';

const TRUST_CONFIG = {
  new: {
    label: 'New',
    icon: Shield,
    multiplier: '0.7x',
    description: 'Recently joined the platform'
  },
  active: {
    label: 'Active',
    icon: CheckCircle,
    multiplier: '1.0x',
    description: 'Regular supporter with good standing'
  },
  verified: {
    label: 'Verified',
    icon: Star,
    multiplier: '1.3x',
    description: 'Verified builder with successful projects'
  },
  mentor: {
    label: 'Mentor',
    icon: Award,
    multiplier: '1.6x',
    description: 'Expert contributor and community leader'
  }
};

export function TrustBadge({ level, showMultiplier = false, size = 'default' }) {
  const config = TRUST_CONFIG[level] || TRUST_CONFIG.new;
  const IconComponent = config.icon;

  const sizeClasses = {
    small: 'text-xs px-1.5 py-0.5',
    default: 'text-xs px-2 py-0.5',
    large: 'text-sm px-3 py-1'
  };

  return (
    <div 
      className={`trust-badge ${getTrustBadgeClass(level)} ${sizeClasses[size]}`}
      title={config.description}
      data-testid={`trust-badge-${level}`}
    >
      <IconComponent className={size === 'small' ? 'w-3 h-3' : 'w-3.5 h-3.5'} />
      <span>{config.label}</span>
      {showMultiplier && (
        <span className="opacity-70">{config.multiplier}</span>
      )}
    </div>
  );
}

export function TrustScoreDisplay({ level, score }) {
  const config = TRUST_CONFIG[level] || TRUST_CONFIG.new;
  const IconComponent = config.icon;

  return (
    <div className="flex items-center gap-3 p-4 bg-slate-50 rounded-xl">
      <div className={`p-3 rounded-xl ${
        level === 'mentor' ? 'bg-purple-100' :
        level === 'verified' ? 'bg-green-100' :
        level === 'active' ? 'bg-blue-100' :
        'bg-slate-100'
      }`}>
        <IconComponent className={`w-6 h-6 ${
          level === 'mentor' ? 'text-purple-600' :
          level === 'verified' ? 'text-green-600' :
          level === 'active' ? 'text-blue-600' :
          'text-slate-600'
        }`} />
      </div>
      <div>
        <div className="flex items-center gap-2">
          <span className="font-semibold text-slate-900">{config.label}</span>
          <span className="text-sm text-slate-500">{config.multiplier} multiplier</span>
        </div>
        <p className="text-sm text-slate-600">{config.description}</p>
      </div>
    </div>
  );
}
